import ManualPaymentAccounts from '../../components/ManualPaymentAccounts';

export default function ManualPaymentAccountsScreen() {
  return <ManualPaymentAccounts />;
}
